import { Head, Link, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface TodoCategory {
  id: number
  name: string
  status: number
  usage_count: number
}

interface Props {
  todo_categories: TodoCategory[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/todo_categories" },
  { title: "Todo Categories", href: "/admin/todo_categories" },
]

export default function Index({ todo_categories }: Props) {
  const handleDelete = (id: number, usageCount: number) => {
    const message =
      usageCount > 0
        ? "This category is in use. It will be deactivated instead of deleted. Continue?"
        : "Are you sure you want to delete this category?"

    if (confirm(message)) {
      router.delete(`/admin/todo_categories/${id}`)
    }
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Todo Categories" />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Todo Categories</h1>
          <Link
            href="/admin/todo_categories/new"
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Category
          </Link>
        </div>

        {todo_categories.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  ID
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Name
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  In Use
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {todo_categories.map((tc) => (
                <tr key={tc.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {tc.id}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {tc.name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {tc.usage_count > 0 ? tc.usage_count : ""}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/admin/todo_categories/${tc.id}/edit`}
                      className="text-hpi-active-blue mr-2 hover:underline"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(tc.id, tc.usage_count)}
                      className="text-hpi-red hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No todo categories found.</p>
        )}
      </div>
    </AppLayout>
  )
}
